import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import React, { ReactNode } from 'react';

import { ReactComponent as CloseIcon } from '../../assets/img/icon/Close.svg';
import { useStyles } from './styles';

interface DialogProps {
  open: boolean;
  title?: ReactNode;
  content: ReactNode;
  actions: ReactNode;
  fullWidth?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  onClose: () => void;
  onOpen?: () => void;
  disableBackdropClick?: boolean;
  TransitionComponent?: any;
}

const SharedDialog: React.FC<DialogProps> = ({
  open,
  title,
  content,
  actions,
  onClose,
  TransitionComponent,
}) => {
  const styles = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={TransitionComponent}
    >
      <DialogTitle disableTypography className={styles.root}>
        <Typography variant="h6" className={styles.title}>
          {title}
        </Typography>
        {onClose && (
          <IconButton
            aria-label="close"
            className={styles.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
};

SharedDialog.displayName = 'SharedDialog';

export default SharedDialog;
